import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabaseEnabled = !!(supabaseUrl && supabaseAnonKey);

const supabaseStub = {
  auth: {
    getSession: async () => ({ data: { session: null }, error: new Error("Supabase no configurado") }),
    onAuthStateChange: (_: any) => ({
      data: { subscription: { unsubscribe: () => {} } },
      error: new Error("Supabase no configurado"),
    }),
    signInWithPassword: async () => ({ data: null, error: new Error("Supabase no configurado") }),
    signUp: async () => ({ data: null, error: new Error("Supabase no configurado") }),
    signOut: async () => ({ error: null }),
  },
  from() {
    const self: any = {
      select: () => Promise.resolve({ data: null, error: new Error("Supabase no configurado") }),
      eq: () => self,
      order: () => self,
      insert: () => Promise.resolve({ data: null, error: new Error("Supabase no configurado") }),
      update: () => Promise.resolve({ data: null, error: new Error("Supabase no configurado") }),
      delete: () => Promise.resolve({ data: null, error: new Error("Supabase no configurado") }),
    };
    return self;
  },
};

export const supabase: any = supabaseEnabled
  ? createClient(supabaseUrl as string, supabaseAnonKey as string)
  : supabaseStub;
